import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import _uniqueId from 'lodash/uniqueId';
import { removeItemByVal, convertViewPortWidthToPixel } from 'utils/utils.js';

export default function SurveyMultiSelector({colNum=3, onComplete,title,description, items, selectedItems, setSelectedItems, minReq, maxReq, replace=false}) {
  const [valid, setValid] = useState(false);
  const emptyItemNum = colNum - (items.length % colNum);
  let emptyItemDom = [];

  let itemWidth = null;
  if(colNum === 3)
  {
    itemWidth = 31;
  }
  else if(colNum === 4)
  {
    itemWidth = 23;
  }
  else
  {
    itemWidth = 48;
  }
  useEffect(()=>{
    validate();
  },[selectedItems])
  let handleNext = (e) => {
    if(onComplete)
    {
      onComplete();
    }
  }
  const handleSelectItem = (e) => {
    let targetNo = e.currentTarget.getAttribute("data-no");
    
    if(maxReq && selectedItems.length >= maxReq && replace === false)
    {
      return;
    }
    if(targetNo)
    {
      //targetNo = parseInt(targetNo);
      if(replace === true)
      {
        setSelectedItems([targetNo]);
      }
      else
      {
        let newSelectedItem = selectedItems;
        newSelectedItem.push(targetNo);
        setSelectedItems([...newSelectedItem]);
      }
    }
  }
  const handleRemoveItem = (e) => {
    let targetNo = e.currentTarget.getAttribute("data-no");
    if(targetNo)
    {
      let newSelectedItem = removeItemByVal(selectedItems, (targetNo));
      setSelectedItems([...newSelectedItem]);
    }
  }

  const validate = () => {
    if(minReq && minReq > selectedItems.length)
    {
      setValid(false);
      return false;
    }
    if(maxReq && maxReq < selectedItems.length)
    {
      setValid(false);
      return false;
    }
    setValid(true);
    return true;
  }

  for(let i = 0; i < emptyItemNum; ++i)
  {
    emptyItemDom.push(<EmptyItem key={`${_uniqueId('empty-dom-')}-${i}`} itemWidth={itemWidth}></EmptyItem>);
  }

  return (
    <SurveyWrapper>
      <HeadWrapper key={`survey-multi-selector-header`}>
      {
        (description)
        ?(<>
          <HeaderWrapper >{title}</HeaderWrapper>
          <DescriptionWrapper >{description}</DescriptionWrapper>
        </>
        )
        :(<HeaderWrapper key={'survey-multi-selector-header'} style={{marginBottom: `calc(100vw * (38 / 375))`}}>{title}</HeaderWrapper>)
      }
      </HeadWrapper>
      <BodyWrapper key={'survey-multi-selector-body'}>

        <ItemList>
        {
          items.map((value, index)=>{
            if(selectedItems.includes(value['no']))
            {
              return(<EnabledItem 
                  onClick={handleRemoveItem}
                  key={`${_uniqueId('item-selected-key-')}-${value['no']}`} 
                  data-no={value['no']}
                  itemWidth={itemWidth}
                >{value['name']}</EnabledItem>);
            }
            else
            {
              return(
                <DisabledItem 
                  onClick={handleSelectItem}
                  key={`${_uniqueId('item-unselected-key-')}-${value['no']}`} 
                  data-no={value['no']}
                  itemWidth={itemWidth}
                >{value['name']}</DisabledItem>
              )
            }
          })
        }
        { emptyItemDom }
        </ItemList>
        {
          (valid)
          ?(<CompleteBtn onClick={handleNext}>
          다음
          </CompleteBtn>)
          :(<DisabledCompleteBtn>
          다음
          </DisabledCompleteBtn>)
          
        }
        
      </BodyWrapper>
    </SurveyWrapper>
  );
}
const SurveyWrapper = styled.div`
  padding : calc(100vw * (17.5 / 375)) calc(100vw * (17 / 375)) 0 ;
`;
const HeaderWrapper = styled.div`
  font-weight: bold;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (29 / 375));
  margin-bottom : calc(100vw * (11 / 375));
`;
const HeadWrapper = styled.div`
`
const BodyWrapper = styled.div`
`
const DescriptionWrapper = styled.div`
  color : #989898;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  margin-bottom : calc(100vw * (36 / 375));
`;

const StartTxt = styled.p`
  font-weight: bold;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (29 / 375));
  color: #121212;
`
const CompleteBtn = styled.div`
  position: fixed;
  width: 100%;
  height: calc(100vw * (72 / 375));
  bottom: 0;
  background: #FFCF19;
  z-index: 300;
  left: 0;
  line-height: calc(100vw * (72 / 375));
  text-align: center;
  font-weight: bold;
  font-size: calc(100vw * (18 / 375));
`;
const DisabledCompleteBtn = styled.div`
  position: fixed;
  width: 100%;
  height: calc(100vw * (72 / 375));
  bottom: 0;
  background: #D8D8D8;
  color:#989898;
  z-index: 300;
  left: 0;
  line-height: calc(100vw * (72 / 375));
  text-align: center;
  font-weight: bold;
  font-size: calc(100vw * (18 / 375));
`;
const ItemList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const DisabledItem = styled.div`
  display:inline-block;
  width : ${(props) => props.itemWidth}%;
  background: #F7F7F7;
  border: 1px solid #F7F7F7;
  border-radius: 2px;
  text-align: center;
  margin-bottom : 10px;
  padding: calc(100vw * (7 / 375)) 0;
  font-size: calc(100vw * (14/ 375)) ;
  font-weight: 500;
  color: #121212;
`;

const EmptyItem = styled.div`
  display:inline-block;
  width : ${(props) => props.itemWidth}%;
  border-radius: 2px;
  text-align: center;
  margin-bottom : 10px;
  padding: calc(100vw * (7 / 375)) 0;
  font-size: calc(100vw * (14 / 375)) ;
  font-weight: 500;

`;
const EnabledItem = styled.div`
  display:inline-block;
  width : ${(props) => props.itemWidth}%;
  border-radius: 2px;
  text-align: center;
  margin-bottom : 10px;
  padding: calc(100vw * (7 / 375)) 0;
  font-size: calc(100vw * (14 / 375)) ;
  font-weight: 500;
  color: #121212;
  background: #FFF4D8;
  border: 1px solid #FFCF19;
  box-sizing: border-box;
  border-radius: 2px;
`;